import React from "react";
import { Route, Routes } from "react-router-dom";

import ProductCategories from "@/components/screens/ProductCategories";
import ProductCategoriesFormPage from "@/components/screens/ProductCategoriesFormPage";
import { PRODUCT_CATEGORY_DETAILS_MESSAGES } from "@/messages/product-categories/product-categories-form-page.messages";
import { PRODUCT_CATEGORIES_MESSAGES } from "@/messages/product-categories/product-categories.messages";

const ProductCategoriesPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<ProductCategories messages={PRODUCT_CATEGORIES_MESSAGES} />} />
      <Route
        path="/create/:lang"
        element={<ProductCategoriesFormPage messages={PRODUCT_CATEGORY_DETAILS_MESSAGES} />}
      />
      <Route
        path="/update/:categoryId/:lang"
        element={
          <ProductCategoriesFormPage messages={PRODUCT_CATEGORY_DETAILS_MESSAGES} isEditing />
        }
      />
      <Route path="/" element={<ProductCategories messages={PRODUCT_CATEGORIES_MESSAGES} />} />
    </Routes>
  );
};

export default ProductCategoriesPage;
